import { createReducer, on } from '@ngrx/store';
import { IEMData, IPromiseOfPayment } from '@dch/billing-business-logic';
import {
  getPromiseOfPaymentRequest,
  getPromiseOfPaymentSuccess,
  getPromiseOfPaymentFailure,
} from '../actions';

export interface PromiseOfPaymentState {
  byAccountNumber: {
    [accountNumber: string]: IEMData<IPromiseOfPayment>;
  };
}

export const initialState: PromiseOfPaymentState = {
  byAccountNumber: {},
};

export const promiseOfPaymentReducer = createReducer(
  initialState,
  on(getPromiseOfPaymentRequest, (state, { billingAccountNumber }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        result: null,
        isFetching: true,
        hasError: false,
      },
    },
  })),
  on(
    getPromiseOfPaymentSuccess,
    (state, { billingAccountNumber, promiseOfPayment }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          result: promiseOfPayment,
          isFetching: false,
          hasError: false,
        },
      },
    })
  ),
  on(getPromiseOfPaymentFailure, (state, { billingAccountNumber }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        result: null,
        isFetching: false,
        hasError: true,
      },
    },
  }))
);
